import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { MANAGE_ALARM_CONFIG_UPDATE } from './url-constants';

type ManageAlarmsConfigUpdateEndpointSpecification = ApiEndpointSpecification;
export const ManageAlarmsConfigUpdateEndpointSpecification: ManageAlarmsConfigUpdateEndpointSpecification = {
    url: MANAGE_ALARM_CONFIG_UPDATE,
    method: HttpMethod.PUT,
    requestParamsSchemaName: 'ManageAlarmsConfigUpdateRequestParams',
    requestBodySchemaName: 'ManageAlarmsConfigUpdateRequestBody',
    okResponseSchemaName: 'ManageAlarmsConfigUpdateOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3
};

export const invokeManageAlarmsConfigUpdate = Helpers.makeApiRequestFn<
    Types.ManageAlarmsConfigUpdateRequestParams,
    Types.ManageAlarmsConfigUpdateRequestBody,
    Types.ManageAlarmsConfigUpdateOkResponse
>(ManageAlarmsConfigUpdateEndpointSpecification);
